import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { Loader } from '../../../components/Loader';
import { selectanKanbanCacheStatus } from '../selectors';
import { fetchKanbanCacheStatus } from '../actions';
import { Cell, List, Row } from '../../../components/List';
import { HBox, VBox } from '../../../components/Box';
import dayjs from 'dayjs';

const Container = styled.div`
  .item-list .row .cell {
    padding: 3px;
  }
  font-size: 12px;
  .propshistory {
    border-left: 2px solid black;
    margin-left: 12px;
    max-width: 300px;
    .cell:nth-child(2) {
      width: 100px;
    }
  }
`;
const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class KanbanCacheStatusComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.update();
  }

  update() {
    console.log('update');
    this.props.fetch();
    this.timeout(this.update.bind(this), 3000);
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (!this.props.status) return <Loader />;
    return (
      <Container>
        <HBox gap={24}>
          <List>
            <Row isHeader>
              <Cell>queued</Cell>
              <Cell>id</Cell>
              <Cell>name</Cell>
              <Cell>time since last update</Cell>
              <Cell>update duration</Cell>
            </Row>
            {_.orderBy(this.props.status.columns, c => c.checkFirst || Infinity).map(this.renderColumn.bind(this))}
          </List>
          <List className="propshistory">
            <Row isHeader>
              <Cell>Changed properties:</Cell>
            </Row>
            {_.orderBy(this.props.status.changeHistory, o => o.time)
              .reverse()
              .map((item, i) => (
                <Row key={`${item.property.propertyName}-${i}`} data-key={`${item.property.propertyName}-${i}`}>
                  <Cell>{item.property.propertyName}</Cell>
                  <Cell>{dayjs(item.time).format('HH:mm:ss')}</Cell>
                </Row>
              ))}
          </List>
        </HBox>
      </Container>
    );
  }

  renderColumn(c) {
    return (
      <Row key={c.column.id}>
        <Cell>{c.dirty ? <Loader small /> : null}</Cell>
        <Cell>{c.column.id}</Cell>
        <Cell>{c.column.label}</Cell>
        <Cell>{c.msSinceUpdate ? `${c.msSinceUpdate / 1000} second ago` : null}</Cell>
        <Cell>{c.lastDuration ? `${c.lastDuration / 1000} s` : null}</Cell>
      </Row>
    );
  }
}

KanbanCacheStatusComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    status: selectanKanbanCacheStatus(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchKanbanCacheStatus());
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const KanbanCacheStatus = compose(
  withConnect,
  withRouter,
)(KanbanCacheStatusComp);
